import { createParser, parseAsString, parseAsArrayOf } from 'nuqs';
import { components } from '@/api/skippay/generated/gcss';

export const SELECT_ALL_VALUE = 'select_all';

export const parseAsSearchString = parseAsString.withOptions({
	history: 'replace',
	shallow: true,
	throttleMs: 300,
});

export const parseAsFilterArray = parseAsArrayOf(parseAsString).withDefault([]).withOptions({
	history: 'replace',
	shallow: true,
	throttleMs: 300,
});

// -- GCSS --
export const parseAsProductSort = createParser<components['schemas']['ProductSort'] | undefined>({
	parse(value) {
		const valid = ['priceAmount', '-priceAmount'];
		return valid.includes(value ?? '')
			? (value as components['schemas']['ProductSort'])
			: undefined;
	},
	serialize(value) {
		return value ?? '';
	},
}).withOptions({
	history: 'replace',
	shallow: true,
	throttleMs: 300,
});

export const parseAsAvailability = createParser<components['schemas']['Availability'] | undefined>({
	parse(value) {
		return value === 'IN_STOCK' ? 'IN_STOCK' : undefined;
	},
	serialize(value) {
		return value ?? '';
	},
}).withOptions({
	history: 'replace',
	shallow: true,
	throttleMs: 300,
});

export const parseAsBooleanString = createParser<'true' | 'false' | undefined>({
	parse(value) {
		if (value === 'true') return 'true';
		if (value === 'false') return 'false';
		return undefined;
	},
	serialize(value) {
		return value ?? '';
	},
}).withOptions({
	history: 'replace',
	shallow: true,
	throttleMs: 300,
});
